<template>
	<page>
		<title-view>משחקים חמים </title-view>
		<row>
			<c-col>
				<games-table
					public="1"
					@edit="onEdit"
					@share="onShare"
				/>
			</c-col>
		</row>
		<popup-dialog v-model="openModal">
			<span slot="header">עריכת משחק</span>
			<game-form @save="onSave" />
		</popup-dialog>
		<share-dialog
			v-model="shareDialogOpen"
			:game="shareGame"
		/>
	</page>
</template>

<script>
import GameForm from "src/view/games/GameForm";
import GamesTable from "src/view/games/GamesTable";
import GameModule from "src/store/modules/Game.module";
import ShareDialog from "dev/view/share/ShareDialog";

export default {
	name: "HotGamesView",
	components: { GamesTable, GameForm, ShareDialog },
	data () {
		return {
			openModal: false,
			shareDialogOpen: false,
			shareGame: {},
		};
	},
	methods: {
		onShare (game) {
			this.shareGame = game;
			this.shareDialogOpen = true;
		},
		onEdit (Game) {
			this.$store.commit(GameModule.types.GET, Game);
			this.openModal = true;
		},
		onSave (game) {
			this.openModal = false;
			this.$store.commit(GameModule.types.GET, game);
			this.$router.push({ name: "game-question", params: { id: game.id } });
		},
	},
};
</script>

<style scoped>
</style>
